import { createSlice } from '@reduxjs/toolkit'

export const DENSITY_COMPACT = 'compact'
export const DENSITY_DEFAULT = 'default'
export const DENSITY_COMFORTABLE = 'comfortable'

export const DENSITY_OPTIONS = [
	DENSITY_COMPACT,
	DENSITY_DEFAULT,
	DENSITY_COMFORTABLE,
]

const initialState = {
	// User's actual selection. Persisted via redux-persist.
	// mode: DENSITY_DEFAULT,
	mode: DENSITY_COMPACT,
}

export const densitySlice = createSlice({
	name: 'density',
	initialState,
	reducers: {
		setDensity: (state, action) => {
			if (DENSITY_OPTIONS.includes(action.payload)) {
				state.mode = action.payload
			}
		},
	},
})

export const { setDensity } = densitySlice.actions

export default densitySlice.reducer